import { Routes, Route } from "react-router";
import SimProviderMain from './views/main';
import { useSelector } from "react-redux";
import { HasPermission } from "Core/security"
const SimProviderView = (props) => {
    const user = useSelector(state => state.securityRedux.user);
    return (
        <>
            <Routes>
                {HasPermission(user, "simp") && <Route path="list" element={<SimProviderMain />} />}
            </Routes>
        </>
    )
}
export default SimProviderView